// Reconstructed from the supplied production build; original component names were unavailable.
import { React } from "../vendor/runtime.js";
import { api } from "../services/api.js";
const AdminAuthContext = React.createContext();
const useAdminAuth = () => React.useContext(AdminAuthContext);
const AdminAuthProvider = ({ children: e }) => {
  const [t, n] = React.useState(null),
    [r, a] = React.useState(true),
    [l, c] = React.useState(null);
  React.useEffect(() => {
    (async () => {
      const g = localStorage.getItem("adminToken");
      if (g)
        try {
          api.defaults.headers.common.Authorization = `Bearer ${g}`;
          const y = await api.get("/admin/verify");
          y.data.valid
            ? n(y.data.user)
            : (localStorage.removeItem("adminToken"),
              delete api.defaults.headers.common.Authorization);
        } catch (y) {
          (console.error("Admin auth verification error:", y),
            localStorage.removeItem("adminToken"),
            delete api.defaults.headers.common.Authorization);
        }
      a(false);
    })();
  }, []);
  const h = {
    adminUser: t,
    loading: r,
    error: l,
    login: async (p, g) => {
      var y, v;
      c(null);
      try {
        const j = await api.post("/admin/login", {
            email: p,
            password: g,
          }),
          { token: N, user: b } = j.data;
        return (
          localStorage.setItem("adminToken", N),
          (api.defaults.headers.common.Authorization = `Bearer ${N}`),
          n(b),
          true
        );
      } catch (j) {
        return (
          console.error("Admin login error:", j),
          c(
            ((v = (y = j.response) == null ? undefined : y.data) == null ? undefined : v.message) ||
              "Failed to login",
          ),
          false
        );
      }
    },
    logout: () => {
      (localStorage.removeItem("adminToken"),
        delete api.defaults.headers.common.Authorization,
        n(null));
    },
    isAdmin: !!t,
  };
  return <AdminAuthContext.Provider value={h}>{e}</AdminAuthContext.Provider>;
};
export { AdminAuthContext, useAdminAuth, AdminAuthProvider };
